package com.milta.feature.optimizationquota.presentation

import com.milta.core.localization.OptimizationQuotaStrings
import com.milta.core.network.OptimizationQuotaExceededException
import com.milta.feature.optimizationquota.domain.entity.OptimizationAction
import com.milta.feature.optimizationquota.domain.entity.OptimizationHistoryEntry
import com.milta.feature.optimizationquota.domain.entity.OptimizationQuota

/**
 * MIL-97 — texts composed from [OptimizationQuotaStrings], shared by the mobile screens and the
 * web dashboard (Compose HTML can't use the mobile composables, but can use these).
 */

/** Replaces each `{key}` of [template]. */
fun String.fillPlaceholders(vararg values: Pair<String, Any>): String =
    values.fold(this) { acc, (key, value) -> acc.replace("{$key}", value.toString()) }

/** "3 / 100" — the counter of "Mes optimisations" (Profile, Paramètres) and of the Admin pages. */
val OptimizationQuota.ratioLabel: String get() = OptimizationQuotaFormat.ratio(remaining, limit)

/**
 * R11 — "Quota d'optimisations atteint — remise à zéro le 14/11". The reset date comes from the
 * error's extensions, else from the last known counter; without either the date part is dropped.
 */
fun OptimizationQuotaStrings.quotaReachedMessage(resetAt: String?): String {
    val date = OptimizationQuotaFormat.dayMonth(resetAt)
    return if (date.isEmpty()) exhaustedTitle else quotaReachedResetOn.fillPlaceholders("date" to date)
}

/** The reset date carried by a quota 403, if [error] is one. */
val Throwable.quotaResetAt: String?
    get() = (this as? OptimizationQuotaExceededException)?.resetAt

fun OptimizationQuotaStrings.actionLabel(action: OptimizationAction?): String = when (action) {
    null -> "—"
    OptimizationAction.CreateOwnRoute -> actionCreateOwnRoute
    OptimizationAction.OptimizeRoute -> actionOptimizeRoute
    OptimizationAction.CreateRouteBatch -> actionCreateRouteBatch
    OptimizationAction.ReoptimizeRouteBatch -> actionReoptimizeRouteBatch
    OptimizationAction.ReoptimizeOnStopAdded -> actionReoptimizeOnStopAdded
    OptimizationAction.ReoptimizeInPlace -> actionReoptimizeInPlace
}

/** "Lot du 26/10" for a batch action, "Tournée du 26/10" otherwise; "—" without a date. */
fun OptimizationQuotaStrings.targetLabel(entry: OptimizationHistoryEntry): String {
    val date = OptimizationQuotaFormat.dayMonth(entry.routeDate)
    if (date.isEmpty()) return "—"
    val isBatch = entry.routeBatchId != null && entry.routeId == null ||
        entry.action == OptimizationAction.CreateRouteBatch ||
        entry.action == OptimizationAction.ReoptimizeRouteBatch
    return (if (isBatch) targetBatch else targetRoute).fillPlaceholders("date" to date)
}
